import React from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { GetCacheKey } from '../../services/common/utils';
import { redirecturl } from '../../services/common/redirect';
import Loadingcomponent from '../loader/loadingcomponent';

const XpressProfitBanner = ({ psmItem }) => {
  const navigate = useNavigate();

  const {
    data: { data } = {},
    isLoading,
    isFetching,
  } = useQuery(
    [
      GetCacheKey(psmItem?.uniqueid),
      psmItem?.method,
      JSON.parse(psmItem?.sourceid),
      {},
    ],
    {
      retry: false,
      retryOnMount: false,
      cacheTime: 300000,
      staleTime: 300000,
    }
  );

  const handleLoadBalance = () => {
    let url = data?.response[0]?.banners[0]?.url;

    if (url) {
      redirecturl(url, navigate);
    } else {
      navigate('/load-balance');
    }
  };

  if (isLoading || isFetching) {
    return <Loadingcomponent />;
  }

  return (
    <div
      class="contedit-banner-okw1 mt-4"
      style={{ backgroundColor: psmItem?.elementmeta?.backgroundcolor }}
    >
      <div>
        <h5 style={{ color: psmItem?.elementmeta?.titletextcolor }}>
          {psmItem?.elementmeta?.title}
        </h5>
        <h1
          class="mb-2"
          style={{ color: psmItem?.elementmeta?.subtitletextcolor }}
        >
          {psmItem?.elementmeta?.subtitle}
        </h1>
        <div class="w-40 pt-4">
          <button
            class="custom_btn custom_btn_primary btn_block mt-5"
            style={{
              backgroundColor: psmItem?.elementmeta?.buttoncolor,
              color: psmItem?.elementmeta?.buttontextcolor,
            }}
            onClick={handleLoadBalance}
          >
            {psmItem?.elementmeta?.buttontext}
          </button>
        </div>
      </div>

      <div class="cotedit-banner-img">
        <img
          src={
            data?.response[0]?.banners[0]?.path ||
            process.env.PUBLIC_URL + '/assets/images/Banners_Bundles.png'
          }
          alt=""
          title=""
        />
      </div>
    </div>
  );
};

export default XpressProfitBanner;
